export const topFaqItems = [
  {
    question: 'HelpPage.topFaq.buy.question',
    answer: 'HelpPage.topFaq.buy.answer',
  },
  {
    question: 'HelpPage.topFaq.sell.question',
    answer: 'HelpPage.topFaq.sell.answer',
  },
  {
    question: 'HelpPage.topFaq.fees.question',
    answer: 'HelpPage.topFaq.fees.answer',
  },
  {
    question: 'HelpPage.topFaq.payout.question',
    answer: 'HelpPage.topFaq.payout.answer',
  },
  {
    question: 'HelpPage.topFaq.problem.question',
    answer: 'HelpPage.topFaq.problem.answer',
  },
  {
    question: 'HelpPage.topFaq.contact.question',
    answer: 'HelpPage.topFaq.contact.answer',
  },
];

export const sectionLinks = [
  { label: 'HelpPage.nav.buying', href: '#kaufen' },
  { label: 'HelpPage.nav.selling', href: '#verkaufen' },
  { label: 'HelpPage.nav.shipping', href: '#versand' },
  { label: 'HelpPage.nav.fees', href: '#gebuehren' },
  { label: 'HelpPage.nav.buyerProtection', href: '#kaeuferschutz' },
  { label: 'HelpPage.nav.conditions', href: '#zustaende' },
  { label: 'HelpPage.nav.reviews', href: '#bewertungen' },
  { label: 'HelpPage.nav.contact', href: '#kontakt' },
];

export const faqSections = [
  {
    id: 'kaufen',
    title: 'HelpPage.buying.title',
    items: [
      {
        question: 'HelpPage.buying.find.question',
        answer: 'HelpPage.buying.find.answer',
      },
      {
        question: 'HelpPage.buying.compare.question',
        answer: 'HelpPage.buying.compare.answer',
      },
      {
        question: 'HelpPage.buying.flow.question',
        answer: 'HelpPage.buying.flow.answer',
      },
      {
        question: 'HelpPage.buying.payment.question',
        answer: 'HelpPage.buying.payment.answer',
      },
      {
        question: 'HelpPage.buying.confirm.question',
        answer: 'HelpPage.buying.confirm.answer',
      },
    ],
  },
  {
    id: 'verkaufen',
    title: 'HelpPage.selling.title',
    items: [
      {
        question: 'HelpPage.selling.how.question',
        answer: 'HelpPage.selling.how.answer',
      },
      {
        question: 'HelpPage.selling.required.question',
        answer: 'HelpPage.selling.required.answer',
      },
      {
        question: 'HelpPage.selling.stripe.question',
        answer: 'HelpPage.selling.stripe.answer',
      },
      {
        id: 'stripe-verifizierung',
        open: true,
        question: 'HelpPage.selling.stripeVerification.question',
        answer: 'HelpPage.selling.stripeVerification.answer',
      },
      {
        question: 'HelpPage.selling.payout.question',
        answer: 'HelpPage.selling.payout.answer',
      },
      {
        question: 'HelpPage.selling.afterSale.question',
        answer: 'HelpPage.selling.afterSale.answer',
      },
    ],
    link: {
      label: 'HelpPage.selling.moreLink',
      routeName: 'SellingInfoPage',
    },
  },
  {
    id: 'versand',
    title: 'HelpPage.shipping.title',
    items: [
      {
        question: 'HelpPage.shipping.costs.question',
        answer: 'HelpPage.shipping.costs.answer',
      },
      {
        question: 'HelpPage.shipping.countries.question',
        answer: 'HelpPage.shipping.countries.answer',
      },
      {
        question: 'HelpPage.shipping.tracking.question',
        answer: 'HelpPage.shipping.tracking.answer',
      },
      {
        question: 'HelpPage.shipping.packaging.question',
        answer: 'HelpPage.shipping.packaging.answer',
      },
      {
        question: 'HelpPage.shipping.missing.question',
        answer: 'HelpPage.shipping.missing.answer',
      },
    ],
  },
  {
    id: 'gebuehren',
    title: 'HelpPage.fees.title',
    items: [
      {
        question: 'HelpPage.fees.listing.question',
        answer: 'HelpPage.fees.listing.answer',
      },
      {
        question: 'HelpPage.fees.seller.question',
        answer: 'HelpPage.fees.seller.answer',
      },
      {
        question: 'HelpPage.fees.buyer.question',
        answer: 'HelpPage.fees.buyer.answer',
      },
      {
        question: 'HelpPage.fees.protection.question',
        answer: 'HelpPage.fees.protection.answer',
      },
      {
        question: 'HelpPage.fees.shipping.question',
        answer: 'HelpPage.fees.shipping.answer',
      },
      {
        question: 'HelpPage.fees.payout.question',
        answer: 'HelpPage.fees.payout.answer',
      },
    ],
  },
  {
    id: 'bewertungen',
    title: 'HelpPage.reviews.title',
    items: [
      {
        question: 'HelpPage.reviews.when.question',
        answer: 'HelpPage.reviews.when.answer',
      },
      {
        question: 'HelpPage.reviews.why.question',
        answer: 'HelpPage.reviews.why.answer',
      },
    ],
  },
];

export const conditionItems = [
  {
    title: 'HelpPage.conditions.new.title',
    text: 'HelpPage.conditions.new.text',
  },
  {
    title: 'HelpPage.conditions.likeNew.title',
    text: 'HelpPage.conditions.likeNew.text',
  },
  {
    title: 'HelpPage.conditions.veryGood.title',
    text: 'HelpPage.conditions.veryGood.text',
  },
  {
    title: 'HelpPage.conditions.good.title',
    text: 'HelpPage.conditions.good.text',
  },
  {
    title: 'HelpPage.conditions.acceptable.title',
    text: 'HelpPage.conditions.acceptable.text',
  },
];
